import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';

import { SCHEDULED_ASSIGNMENTS_EVENTS } from 'src/constants/local-storage.constants';
import { AppStartListening } from 'src/store';
import {
  addScheduledAssignmentsEvent,
  removeScheduledAssignmentsEvent,
  updateScheduledAssignmentsEvent,
} from 'src/store/features';

export const scheduledAssignmentEventsListener = createListenerMiddleware();

const startListeningScheduledAssignmentEvents =
  scheduledAssignmentEventsListener.startListening as AppStartListening;

startListeningScheduledAssignmentEvents({
  matcher: isAnyOf(
    addScheduledAssignmentsEvent,
    removeScheduledAssignmentsEvent,
    updateScheduledAssignmentsEvent,
  ),
  effect: (action, api) => {
    localStorage.setItem(
      SCHEDULED_ASSIGNMENTS_EVENTS,
      JSON.stringify(api.getState().scheduledAssignmentEvents),
    );
  },
});
